export default "__VITE_ASSET__b4c85d58__"